import React, { useEffect, useContext, memo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';
import errorimg from '../../assets/images/404.png';
import logo from '../../assets/images/logo-gray.png';
import '../../css/ErrorPage.css';
import Button from '../../components/common/ui/Button.jsx';

function Error() {
  const context = useContext(AppSettings);

  useEffect(() => {
    context.handleSetAppSidebarNone(true);
    context.handleSetAppHeaderNone(true);
    context.handleSetAppContentClass('p-0');

    return () => {
      context.handleSetAppSidebarNone(false);
      context.handleSetAppHeaderNone(false);
      context.handleSetAppContentClass('');
    };

    // eslint-disable-next-line
  }, []);

  const navigate = useNavigate();

  return (
    <div className="parent-container">
      <div className="error-container">
        <div className="error-logo">
          <img src={logo} alt="Logo" />
        </div>
        <div className="error-content">
          <div className="error-code">
            <img src={errorimg} alt="Logo" />
          </div>

          <p className="error-message">
            The Server encountered an internal error and unable to process your request at this time.
            Please try again after sometime or contact your administrator if the problem persists.
          </p>
          <div className="d-flex justify-content-center">
            <Button
              variant="primary"
              className="me-2"
              onClick={() => { navigate('/') }}
              label="BACK TO LOGIN"
              type="button"
              status="primary"
              disabled={false}
            />
          </div>
        </div>
        <div className="error-footer">
          <p>Copyright © {new Date().getFullYear()} by inmate inbox. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
}

export default memo(Error);
